import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, letting later Tailwind utilities beat earlier ones.
 *
 * `clsx` flattens conditionals and arrays; `twMerge` then resolves conflicts
 * within the same Tailwind group, so a caller passing `className="px-6"` wins
 * over a component's built-in `px-4` instead of the two fighting on specificity.
 * Every component in `components/ui` runs its classes through this.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
